if (document.getElementById('js-members')) {
    var members = $('.js-member');
    members.each(function() {
        var id = $(this).attr('id'),
            name = $(this).data('name');
        edaLoadConsultant('easycons', name, null, id);
    })
}